import React from 'react';
import { Box, Typography } from '@mui/material';

interface EmptyStateProps {
  title: string;
  description: string;
  icon?: React.ReactNode;
  showBackgroundPattern?: boolean;
}

const EmptyState: React.FC<EmptyStateProps> = ({ 
  title, 
  description, 
  icon,
  showBackgroundPattern = false 
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '32px',
        padding: '40px 24px',
        flex: 1,
        position: 'relative',
        alignSelf: 'stretch',
      }}
    >
      {/* Icon */}
      {icon && (
        <Box
          sx={{
            width: '120px',
            height: '120px',
            position: 'relative',
            zIndex: 1,
          }}
        >
          {icon}
        </Box>
      )}
      
      {/* Text Content */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '8px',
          alignItems: 'center',
          alignSelf: 'stretch',
          position: 'relative',
          zIndex: 1,
        }}
      >
        <Typography
          sx={{
            fontFamily: '"HT Mosafer Rounded", "Roboto", "Helvetica", "Arial", sans-serif',
            fontSize: '22px',
            fontWeight: 700,
            lineHeight: '26.4px',
            letterSpacing: '-0.11px',
            color: '#181818',
            textAlign: 'center',
          }}
        >
          {title}
        </Typography>
        
        <Typography
          sx={{
            fontFamily: '"HT Mosafer Rounded", "Roboto", "Helvetica", "Arial", sans-serif',
            fontSize: '16px',
            fontWeight: 400,
            lineHeight: '22.4px',
            color: '#181818',
            textAlign: 'center',
          }}
        >
          {description}
        </Typography>
      </Box>
    </Box>
  );
};

export default EmptyState;

